import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { isNonEmptyString, isStringArray } from '@/api/queries/utils';
import expandHierarchicalPaths from '@/models/filter/utils/expandHierarchicalPaths';
import { applyHierarchicalFilter } from '@/models/filter/utils/hierarchicalFilter';
import { getDeepestHierarchyLevel } from '@/models/filter/utils/hierarchyPath';
import mapHierarchicalOptionsForIndicationMode from '@/models/filter/utils/mapHierarchicalOptionsForIndicationMode';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { LogicalAndFilter } from '@cubejs-client/core';
import { TA_INDICATIONS_FILTER_LIMIT } from '../../filterDefaultLimits';
import { parseTaIndicationFilter } from '../../utils/parseTaIndicationFilter';

const dimensions = [
  `${CLASSIFICATION_CUBE_NAME}.global_therapeutic_area`,
  `${CLASSIFICATION_CUBE_NAME}.global_level_1_indication_name`,
  `${CLASSIFICATION_CUBE_NAME}.global_level_2_indication_name`,
  `${CLASSIFICATION_CUBE_NAME}.global_level_3_indication_name`,
  `${CLASSIFICATION_CUBE_NAME}.global_level_4_indication_name`,
];

const TAE_AREA_OPTIONS: GetOptionsQueryFunction = ({}) => ({
  dimensions,
  limit: TA_INDICATIONS_FILTER_LIMIT,
});

const taIndicationFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.taIndicationsLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: TAE_AREA_OPTIONS,
  mapResult: row => mapHierarchicalOptionsForIndicationMode(row, dimensions),
  processOptions: expandHierarchicalPaths,
  usesOptionPaths: true,
  type: 'treeselect',
  clearable: true,
  placeholder: 'global.filters.formControls.taIndicationsPlaceholder',
  format: ({ value }) => {
    if (!isNonEmptyString(value)) return '';
    return getDeepestHierarchyLevel(value);
  },
  searchable: true,
  selectionMode: 'indication',
  applyFilter: (value, context) => {
    if (!isStringArray(value)) return undefined;
    const allPaths = context?.optionPaths ?? [];

    if (!allPaths.length) {
      const fallbackFilter: LogicalAndFilter = { and: [] };
      applyHierarchicalFilter(fallbackFilter, value, dimensions);
      return fallbackFilter.and.length ? fallbackFilter : undefined;
    }

    return parseTaIndicationFilter(value, allPaths);
  },
};

export default taIndicationFilter;
